import { d as r } from "./index-E8vB_04G.js";
import { l as y } from "./lodash-CQY7Uy6L.js";
import { l as f } from "./index-b-LDu0Rp.js";
import { Permissions as h } from "./permission.js";
import "ddc";
var d = [];
for (var l = 0; l < 256; ++l)
  d.push((l + 256).toString(16).slice(1));
function x(n, t = 0) {
  return (d[n[t + 0]] + d[n[t + 1]] + d[n[t + 2]] + d[n[t + 3]] + "-" + d[n[t + 4]] + d[n[t + 5]] + "-" + d[n[t + 6]] + d[n[t + 7]] + "-" + d[n[t + 8]] + d[n[t + 9]] + "-" + d[n[t + 10]] + d[n[t + 11]] + d[n[t + 12]] + d[n[t + 13]] + d[n[t + 14]] + d[n[t + 15]]).toLowerCase();
}
var m, M = new Uint8Array(16);
function b() {
  if (!m && (m = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !m))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return m(M);
}
var D = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const w = {
  randomUUID: D
};
function P(n, t, i) {
  if (w.randomUUID && !n)
    return w.randomUUID();
  n = n || {};
  var e = n.random || (n.rng || b)();
  return e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128, x(e);
}
function A(n) {
  const t = [], i = [], e = [];
  if (n)
    for (const [o, s] of Object.entries(n.elements)) {
      const a = s.id;
      s.attestationSpecification ? t.push([
        a,
        s.attestationSpecification
      ]) : s.authenticationMethod ? i.push([
        a,
        s.authenticationMethod
      ]) : s.userPermission && e.push([
        a,
        s.userPermission
      ]);
    }
  return {
    attestationSpecs: t,
    authenticationMethods: i,
    userPermissions: e
  };
}
function N(n, t) {
  const i = n.toJSON(), e = t.find(([o, s]) => y.isEqual(i, s.toJSON()));
  if (e)
    return e[0];
}
function g(n) {
  return f.md.sha256.create().update(JSON.stringify(n.toJSON())).digest().toHex();
}
function I(n) {
  const t = new Map(
    n.map((i) => [g(i), i])
  );
  return Array.from(t.values());
}
function C(n, t) {
  const i = new Map(
    n.map((o) => [g(o), o])
  );
  let e = !1;
  return t.forEach((o) => {
    const s = g(o);
    i.has(s) || (i.set(s, o), n.push(o), e = !0);
  }), e;
}
class S {
  /**
   * The data room cannot be changed after it has been published.
   * Participants are still allowed to execute developmentcomputations
   * as long as the required permissions have been granted.
   */
  static get staticDataRoom() {
    return r.GovernanceProtocol.create({
      staticDataRoomPolicy: {}
    });
  }
  /**
   * The addition of compute nodes must be approved by all data owners
   * on whose data the new compute node will depend.
   */
  static get affectedDataOwnersApprove() {
    return r.GovernanceProtocol.create({
      affectedDataOwnersApprovePolicy: {}
    });
  }
}
class B {
  name;
  governanceProtocol;
  description;
  modificationsBuilder;
  /**
   * Create a data room builder object.
   *
   * @param name The name of the data room to be created.
   * @param enclaveSpecs The enclave specification set in which to look-up
   *   enclave specs for enclaves responsible for executing compute nodes.
   *   These specs are provided by the [[`enclaveSpecifications`]] catalogue.
   */
  constructor(t, i, {
    governanceProtocol: e = S.staticDataRoom,
    addBasicUserPermissions: o = !0,
    description: s
  } = {}) {
    this.name = t, s !== void 0 && (this.description = s), this.governanceProtocol = e, this.modificationsBuilder = new v(i, {
      addBasicUserPermissions: o
    });
  }
  /**
   * Add a description to the data room being built.
   */
  addDescription(t) {
    this.description = t;
  }
  /**
   * Add a new data node.
   *
   * @param name Name of the data node.
   * @returns The id that was assigned to the added data node.
   *  This id will be needed when connecting a dataset or when
   *  permissions condering this node are defined.
   */
  addDataNode(t, i = {}) {
    return this.modificationsBuilder.addDataNode(t, i);
  }
  /**
   * Add a new compute node. Specific compute node classes are provided either
   * by the main package or by the respective compute submodules.
   *
   * @returns The id that was assigned to the added compute node.
   *  This id will need to be provided when running computations
   *  or when adding permissions concerning this node.
   */
  addComputeNode(t, i = {}) {
    return this.modificationsBuilder.addComputeNode(t, i);
  }
  /**
   * Add a new airlock node.
   *
   * @returns The id that was assigned to the added airlock node.
   *  This id will need to be provided when running computations
   *  or when adding permissions concerning this node.
   */
  addAirlockNode(t, i, e = {}) {
    return this.modificationsBuilder.addAirlockNode(
      t,
      i,
      e
    );
  }
  /**
   * Add permissions to a user.
   * The authentication is performed on the enclave side based on the method supplied.
   */
  addUserPermission(t, i, e) {
    return this.modificationsBuilder.addUserPermission(
      t,
      i,
      e
    );
  }
  /**
   * Finalize data room construction.
   *
   * Built data rooms still need to be published using [[`Session.publishDataRoom`]]
   * before they can be interacted with.
   *
   * @returns A tuple containing the following elements:
   * (1) A data room object that stores the core properties of the DCR, such
   * as its name, its owner, and the government protocol that defines what changes
   * can be made to the data room's configuration.
   * (2) A list of the recorded modifications that will be applied to the initially
   * empty data room configuration within the enclave.
   */
  build() {
    const t = r.DataRoom.create({
      description: this.description,
      governanceProtocol: this.governanceProtocol,
      id: this.generateId(),
      name: this.name
    }), i = this.modificationsBuilder.buildFlat();
    return t.initialConfiguration = i, t;
  }
  generateId() {
    return P();
  }
}
class v {
  dataRoomId;
  historyPin;
  newAttestationSpecifications;
  newAuthenticationMethods;
  newUserPermissions;
  newComputeNodes;
  existingAttestationSpecifications;
  existingAuthenticationMethods;
  existingUserPermissions;
  changeUserPermissions;
  enclaveSpecs;
  addBasicUserPermissions;
  /**
   * Construct a builder object for constructing lists of modifications that
   * can be applied to existing data room configurations.
   *
   * @param enclaveSpecs The enclave specification set in which to lookup
   *   enclave specs for enclaves responsible for executing compute nodes.
   *   These specs are provided by the [[`enclaveSpecifications`]] catalogue.
   */
  constructor(t, {
    dataRoomId: i,
    historyPin: e,
    dataRoomConfiguration: o,
    addBasicUserPermissions: s = !0
  } = {}) {
    this.dataRoomId = i, this.historyPin = e, this.enclaveSpecs = t, this.addBasicUserPermissions = s, this.newAttestationSpecifications = [], this.newAuthenticationMethods = [], this.newUserPermissions = [], this.newComputeNodes = [], this.changeUserPermissions = [];
    const a = A(
      o
    );
    this.existingAttestationSpecifications = a.attestationSpecs, this.existingAuthenticationMethods = a.authenticationMethods, this.existingUserPermissions = a.userPermissions;
  }
  /**
   * Add a new data node.
   *
   * @param name Name of the data node.
   * @returns The id that was assigned to the added data node.
   *  This id will be needed when connecting a dataset or when
   *  permissions condering this node are defined.
   */
  addDataNode(t, { isRequired: i = !1, nodeId: e } = {}) {
    const o = e !== void 0 ? e : this.generateId(), s = r.ComputeNode.create({
      leaf: {
        isRequired: i
      },
      nodeName: t
    });
    return this.newComputeNodes.push([o, s]), o;
  }
  /**
   * Add a new parameter node.
   *
   * @param name Name of the parameter node.
   * @returns The id that was assigned to the added parameter node.
   */
  addParameterNode(t, { isRequired: i = !1, nodeId: e } = {}) {
    const o = e !== void 0 ? e : this.generateId(), s = r.ComputeNode.create({
      nodeName: t,
      parameter: {
        isRequired: i
      }
    });
    return this.newComputeNodes.push([o, s]), o;
  }
  addAttestationSpecification(t) {
    const i = N(t, [
      ...this.existingAttestationSpecifications,
      ...this.newAttestationSpecifications
    ]);
    if (i === void 0) {
      const e = this.generateId();
      return this.newAttestationSpecifications.push([e, t]), e;
    } else
      return i;
  }
  /**
   * Add a new compute node. Specific compute node classes are provided either
   * by the main package or by the respective compute submodules.
   *
   * @returns The id that was assigned to the added compute node.
   *  This id will need to be provided when running computations
   *  or when adding permissions concerning this node.
   */
  addComputeNode(t, { nodeId: i, attestationId: e } = {}) {
    if (this.enclaveSpecs !== void 0 && this.enclaveSpecs.size > 0) {
      const o = this.enclaveSpecs.get(t.enclaveType);
      if (o !== void 0) {
        const s = o.proto, a = Math.max(
          ...o.workerProtocols
        ), u = r.ComputeNodeProtocol.create({
          version: a
        });
        let c;
        e ? c = e : c = this.addAttestationSpecification(s);
        const p = i !== void 0 ? i : this.generateId(), U = r.ComputeNode.create({
          branch: {
            attestationSpecificationId: c,
            config: t.config,
            dependencies: t.dependencies,
            outputFormat: t.outputFormat,
            protocol: u
          },
          nodeName: t.name
        });
        return this.newComputeNodes.push([p, U]), p;
      } else
        throw Error(
          `This compute node requires an enclave of type ${t.enclaveType} but no corresponding enclave spec was provided to this builder.`
        );
    } else
      throw new Error(
        "You need to provide a dictionary of enclave specifications to the builder before calling this method."
      );
  }
  /**
   * Add a new airlock node.
   *
   * @returns The id that was assigned to the added airlock node.
   *  This id will need to be provided when running computations
   *  or when adding permissions concerning this node.
   */
  addAirlockNode(t, i, { nodeId: e, nodeName: o } = {}) {
    const s = e !== void 0 ? e : this.generateId(), a = o || "", u = r.ComputeNode.create({
      airlock: {
        airlockedDependency: i,
        quotaBytes: t
      },
      nodeName: a
    });
    return this.newComputeNodes.push([s, u]), s;
  }
  addAuthenticationMethod(t) {
    const i = N(t, [
      ...this.existingAuthenticationMethods,
      ...this.newAuthenticationMethods
    ]);
    if (i !== void 0)
      return i;
    {
      const e = this.generateId();
      return this.newAuthenticationMethods.push([e, t]), e;
    }
  }
  /**
   * Add permissions to a user.
   * The authentication is performed on the enclave side based on the method supplied.
   */
  addUserPermission(t, i, e) {
    const o = this.addAuthenticationMethod(i);
    this.addBasicUserPermissions && (e = e.concat([
      h.retrieveDataRoomStatus,
      h.retrieveAuditLog,
      h.retrieveDataRoom,
      h.retrievePublishedDatasets,
      h.executeDevelopmentCompute
    ]));
    const s = this.existingUserPermissions.filter(
      ([u, c]) => c.email === t && c.authenticationMethodId === o
    ), a = this.newUserPermissions.filter(
      ([u, c]) => c.email === t && c.authenticationMethodId === o
    );
    if (s.length > 0) {
      const [u, c] = s[0];
      C(
        c.permissions,
        e
      ) && this.changeUserPermissions.push([u, c]);
    } else if (a.length > 0) {
      const u = a[0][1];
      C(u.permissions, e);
    } else {
      const u = r.UserPermission.create({
        authenticationMethodId: o,
        email: t,
        permissions: I(e)
      });
      this.newUserPermissions.push([this.generateId(), u]);
    }
  }
  buildFlat() {
    const t = [];
    for (const [e, o] of this.newAttestationSpecifications)
      t.push(
        r.ConfigurationElement.create({
          attestationSpecification: o,
          id: e
        })
      );
    for (const [e, o] of this.newComputeNodes)
      t.push(
        r.ConfigurationElement.create({
          computeNode: o,
          id: e
        })
      );
    for (const [e, o] of this.newAuthenticationMethods)
      t.push(
        r.ConfigurationElement.create({
          authenticationMethod: o,
          id: e
        })
      );
    for (const [e, o] of this.newUserPermissions)
      t.push(
        r.ConfigurationElement.create({
          id: e,
          userPermission: o
        })
      );
    for (const [e, o] of this.changeUserPermissions)
      t.push(
        r.ConfigurationElement.create({
          id: e,
          userPermission: o
        })
      );
    return r.DataRoomConfiguration.create({ elements: t });
  }
  /**
   * Build the list of configuration modifications.
   */
  build() {
    const t = [];
    for (const [i, e] of this.newAttestationSpecifications)
      t.push(
        r.ConfigurationModification.create({
          add: {
            element: { attestationSpecification: e, id: i }
          }
        })
      );
    for (const [i, e] of this.newComputeNodes)
      t.push(
        r.ConfigurationModification.create({
          add: {
            element: { computeNode: e, id: i }
          }
        })
      );
    for (const [i, e] of this.newAuthenticationMethods)
      t.push(
        r.ConfigurationModification.create({
          add: {
            element: { authenticationMethod: e, id: i }
          }
        })
      );
    for (const [i, e] of this.newUserPermissions)
      t.push(
        r.ConfigurationModification.create({
          add: {
            element: { id: i, userPermission: e }
          }
        })
      );
    for (const [i, e] of this.changeUserPermissions)
      t.push(
        r.ConfigurationModification.create({
          change: {
            element: { id: i, userPermission: e }
          }
        })
      );
    return t;
  }
  generateId() {
    return P();
  }
}
class R {
  /**
   * Construct a builder object for constructing new data room
   * configuration commits.
   * A configuraton commit contains a list of modifications that
   * can be applied to existing data room configuration.
   *
   * @param dataRoomId The data room to which the modifications should be applied.
   * @param dataRoomConfiguration The current configuration of the data room to be
   *  altered.
   * @param historyPin The current history pin that identifies a specific point in
   *  time within a line of configuration changes.
   * @param enclaveSpecs The enclave specification set in which to look-up
   *  enclave specs for enclaves responsible for executing compute nodes.
   *  These specs are provided by the `decentriq_platform.enclave_specifications`
   *  catalogue.
   */
  constructor(t, i, e, o, s, { addBasicUserPermissions: a = !1 } = {}) {
    this.name = t, this.dataRoomId = i, this.historyPin = o, this.modificationsBuilder = new v(s, {
      addBasicUserPermissions: a,
      dataRoomConfiguration: e,
      dataRoomId: i,
      historyPin: o
    });
  }
  modificationsBuilder;
  /**
   * Add a new data node.
   *
   * @param name Name of the data node.
   * @returns The id that was assigned to the added data node.
   *  This id will be needed when connecting a dataset or when
   *  permissions condering this node are defined.
   */
  addDataNode(t, i = {}) {
    return this.modificationsBuilder.addDataNode(t, i);
  }
  /**
   * Add a new parameter node.
   *
   * @param name Name of the parameter node.
   * @returns The id that was assigned to the added parameter node.
   */
  addParameterNode(t, i = {}) {
    return this.modificationsBuilder.addParameterNode(t, i);
  }
  /**
   * Add a new compute node. Specific compute node classes are provided either
   * by the main package or by the respective compute submodules.
   *
   * @returns The id that was assigned to the added compute node.
   *  This id will need to be provided when running computations
   *  or when adding permissions concerning this node.
   */
  addComputeNode(t, i = {}) {
    return this.modificationsBuilder.addComputeNode(t, i);
  }
  /**
   * Add a new airlock node.
   *
   * @returns The id that was assigned to the added airlock node.
   *  This id will need to be provided when running computations
   *  or when adding permissions concerning this node.
   */
  addAirlockNode(t, i, e = {}) {
    return this.modificationsBuilder.addAirlockNode(
      t,
      i,
      e
    );
  }
  /**
   * Add permissions to a user.
   * The authentication is performed on the enclave side based on the method supplied.
   */
  addUserPermission(t, i, e) {
    return this.modificationsBuilder.addUserPermission(
      t,
      i,
      e
    );
  }
  generateId() {
    return P();
  }
  /**
   * Build the data room configuration commit.
   *
   * @returns The built commit object. This object still needs to be published
   *  and merged in order for it to be made part of the data room configuration.
   */
  build() {
    return r.ConfigurationCommit.create({
      dataRoomHistoryPin: f.util.binary.hex.decode(this.historyPin),
      dataRoomId: f.util.binary.hex.decode(this.dataRoomId),
      id: this.generateId(),
      modifications: this.modificationsBuilder.build(),
      name: this.name
    });
  }
}
const J = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DataRoomBuilder: B,
  DataRoomCommitBuilder: R,
  DataRoomModificationsBuilder: v,
  GovernanceProtocol: S,
  extractConfigurationElements: A
}, Symbol.toStringTag, { value: "Module" }));
export {
  B as D,
  S as G,
  R as a,
  J as b,
  v as c,
  A as e
};
//# sourceMappingURL=builders-D99X3ba6.js.map
